import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "header"
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      size: "mini",
      model: _vm.form,
      rules: _vm.rules,
      "label-width": _vm.inDialog ? "0px" : "80px"
    }
  }, [!_vm.inDialog ? _c("el-form-item", {
    attrs: {
      label: "函证单号",
      prop: "codes"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请录入函证单号"
    },
    model: {
      value: _vm.form.code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "code", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.code"
    }
  })], 1) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: ""
    }
  }, [!_vm.inDialog ? _c("el-button", {
    attrs: {
      type: "primary",
      loading: _vm.loading,
      disabled: !_vm.form.code,
      size: "mini"
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("查询")]) : _vm._e(), _vm.isAdmin || _vm.isCpscAdmin || _vm.isSender ? _c("el-button", {
    attrs: {
      type: "warning",
      size: "mini",
      disabled: _vm.multipleSelection.length === 0,
      loading: _vm.loading
    },
    on: {
      click: _vm.reorder
    }
  }, [_vm._v("重新下单")]) : _vm._e()], 1)], 1), _vm.orderMessage.succeeded.length ? _c("el-alert", {
    staticClass: "alert",
    attrs: {
      title: "成功的订单号",
      type: "success",
      description: _vm.orderMessage.succeeded.join(","),
      "show-icon": ""
    }
  }) : _vm._e(), _vm.orderMessage.failed.length ? _c("el-alert", {
    staticClass: "alert",
    attrs: {
      title: "失败的订单号",
      type: "error",
      description: _vm.orderMessage.failed.join(","),
      "show-icon": ""
    }
  }) : _vm._e()], 1), _c("el-table", {
    ref: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      "row-key": "c61Id"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "selection",
      selectable: _vm.selectable,
      fixed: "left",
      width: "55"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "c61Id",
      label: "订单号",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.c61Id))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "c61CreatedOn",
      label: "创建时间",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(_vm._f("date")(scope.row.c61CreatedOn)))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "类型",
      width: "60",
      prop: "c61Source"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(" " + _vm._s(scope.row.c61Source) + " "), scope.row.c61Source === "订单" ? [_vm._v(" (发函) ")] : scope.row.c61Source === "推送" ? [_vm._v(" (回函) ")] : _vm._e()], 2)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "订单状态",
      width: "92",
      prop: "c61Status"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "问题说明",
      width: "180",
      prop: "c61StatusExplain"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "运单号",
      width: "145",
      prop: "c61TrackingNo"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "发件人",
      width: "95",
      prop: "c61Sender"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "发件电话",
      width: "110",
      prop: "c61SenderTel"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "发件地址",
      width: "180",
      prop: "c61SenderAddr"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "收件人",
      width: "95",
      prop: "c61Receiver"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "收件电话",
      width: "110",
      prop: "c61ReceiverTel"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "收件地址",
      width: "180",
      prop: "c61ReceiverAddr"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "110",
      label: "运费付款方式",
      prop: "c61PaymentType"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "寄件业务类型",
      width: "110",
      prop: "c61TransportType"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "子母件类型",
      width: "100",
      prop: "c61BindingType"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "寄件物品",
      width: "90",
      prop: "c61Content"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "145",
      label: "是否已经写入函证",
      prop: "c61IsRead"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.c61IsRead ? "是" : "否"))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "函证编号列表",
      width: "150",
      prop: "confirmCodes"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "路由数据",
      width: "180",
      prop: "c63RoutingHistory"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };